export const MESSAGE_HISTORY_REQUEST = "MESSAGE_HISTORY_REQUEST";
export const MESSAGE_HISTORY_RESPONSE = "MESSAGE_HISTORY_RESPONSE";
export const MESSAGE_HISTORY_RESET = "MESSAGE_HISTORY_RESET";